<template>
    <div class="container">
      <div class="containbox">
         <Headerbox class="header_contain"  ></Headerbox>
          <Upload v-if="tab==0"></Upload>
              <Tutorials v-if="tab==1"></Tutorials>
<!--           <div class="agreement_box">
             <a href="https://ottepg-moss.cedock.com/tvhelper/agreement/useragreement.html" target="_blank">用户协议</a>｜<a href="https://ottepg-moss.cedock.com/tvhelper/agreement/privacyagreement.html" target="_blank">隐私政策</a>
           </div>
        <div class="apkload_button" @click="downloadapk"  v-if="isMobile">下载欢视助手TV版</div>
        <div style="height: 30px;width: 320px;" v-if="isMobile"></div>-->

    </div>
    </div>
</template>

<script>
 import Headerbox from "../components/headerbox";
 import Upload from "../components/upload";
 import Tutorials from "../components/tutorials";

export default {
  name: "home",
  components: {
    Headerbox,
    Upload,
    Tutorials
  },
  data() {
    return {
       tab:0,
      isMobile:false
    }
  },


  mounted() {
    let userAgent = navigator.userAgent;
    this.isMobile = /mobile|android/i.test(userAgent);
  },
  methods: {
    tabChange(data){
      this.tab=data;
    },

  }
}
</script>

<style scoped>
.container{
/*  width: 1920px;
  height:1080px;*/
/*  height: 900px;
  background: #f7d600;
 width: 100%;*/

   background:url('../assets/homebg.png') no-repeat center bottom;
  background-size:100% 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow-y: scroll;

/*  min-width: 1400px;*/
}
.containbox{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: end;
  flex-wrap: wrap;

}
.header_contain{
  width: 100%;
  height: auto;
 position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.agreement_box{
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #747F97;
  text-align: center;
  margin-bottom: 1%;
  margin-top: 3%;

}
.agreement_box a{
  color: #747F97;
  text-decoration: none;
}



@media screen and (max-width: 600px) {
  .containbox{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;

  }



}

</style>



// WEBPACK FOOTER //
// src/view/home.vue